import React, { createContext, useContext, useReducer } from "react";
import { initialState, reducer } from "./reducer";
import data, { app } from "./data";
import nav from "./nav";
import footer from "./footer";

interface GlobalContextProps {
	state: any;
	dispatch: (action: any) => void;
	app: any;
	data: any;
	nav: any;
	footer: any;
}

const initialData = {};

const GlobalContext = createContext(initialData as GlobalContextProps);

export const GlobalProvider = (props: any) => {
	const [state, dispatch] = useReducer(reducer, initialState);

	return (
		<GlobalContext.Provider
			value={{
				state,
				dispatch,
				app,
				data,
				nav,
				footer,
			}}
		>
			{props.children}
		</GlobalContext.Provider>
	);
};

export const useGlobalContext = () => useContext(GlobalContext);
